import bootstrapAngular from '%app/js/common/services/bootstrapAngular';
import appModuleName from './app';

bootstrapAngular(appModuleName, 'TicketFrontendBundle');
